import React from 'react';
import { IShiftConfig } from '../interfaces/schedule-period.interface';
import { MiniInput } from 'shared/ui';
import { DayConfigRow } from './day-config-row';
import styles from './settings.module.scss';
import { createDefaultDayConfig } from '../lib/convert-rules';

interface IShiftFormProps {
  value: IShiftConfig;
  onChange: (value: IShiftConfig) => void;
}

export const ShiftForm: React.FC<IShiftFormProps> = ({ value, onChange }) => {
  const handleDaysRunningChange = (v: string) => {
    const n = Math.max(1, Number(v) || 1);
    const current = value.workingDays;
    let workingDays: IShiftConfig['workingDays'];
    if (n > current.length) {
      workingDays = [
        ...current,
        ...Array.from({ length: n - current.length }, () =>
          createDefaultDayConfig(false)
        ),
      ];
    } else if (n < current.length) {
      workingDays = current.slice(0, n);
    } else {
      workingDays = current;
    }
    onChange({ ...value, daysRunning: n, workingDays });
  };

  return (
    <div className={styles.form_content}>
      <div className={styles.settings__line}>
        <div className={styles.line__text}>График</div>
        <MiniInput
          inputValue={String(value.daysRunning)}
          onChange={handleDaysRunningChange}
          inputPlaceholder="5"
          inputType="number"
          className={styles.input_count}
          min="1"
        />
        <div className={styles.line__text}>через</div>
        <MiniInput
          inputValue={String(value.daysOver)}
          onChange={(v) =>
            onChange({ ...value, daysOver: Math.max(0, Number(v) || 0) })
          }
          inputPlaceholder="2"
          inputType="number"
          className={styles.input_count}
          min="0"
        />
      </div>

      {value.workingDays.map((day, i) => (
        <DayConfigRow
          key={i}
          label={`День ${i + 1}`}
          value={day}
          onChange={(newConfig) => {
            const workingDays = [...value.workingDays];
            workingDays[i] = newConfig;
            onChange({ ...value, workingDays });
          }}
        />
      ))}
    </div>
  );
};
